import { render, staticRenderFns } from "./customDashboardFilters.vue?vue&type=template&id=6af2151e&scoped=true"
import script from "./customDashboardFilters.vue?vue&type=script&lang=js"
export * from "./customDashboardFilters.vue?vue&type=script&lang=js"
import style0 from "./customDashboardFilters.vue?vue&type=style&index=0&id=6af2151e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af2151e",
  null
  
)

export default component.exports